/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Last_LabelInputs */



/**
* | output |
* | --- |
* | "Last 1:1" |
*
* @param {Team_Last_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_last_label = /** @type {((inputs?: Team_Last_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Last_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Laatste 1:1")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernier one-to-one")
	return /** @type {LocalizedString} */ ("Last 1:1")
});